import moment from 'moment-timezone'

import { ProgressDataType } from './types'
import { ORDER_MILESTONES } from './constants'

export const getStagesOfProgressBarStep = (
    milestoneDates: ProgressDataType,
) => {
    const { porDate, committedDate, actualDate } = milestoneDates
    let isPorDifferentThanCommitted = false
    let isDelayed = false
    let isComplete = false

    if (porDate && !moment(porDate).isSame(moment(committedDate))) {
        isPorDifferentThanCommitted = true
    }

    if (actualDate) {
        isComplete = true
    }

    if (actualDate && moment(actualDate).isAfter(moment(committedDate))) {
        isDelayed = true
    }

    return { isPorDifferentThanCommitted, isComplete, isDelayed }
}

export const getCurrentMilestoneStage = (progressData: ProgressDataType[]) => {
    const pendingStages: { milestone: string }[] = []

    progressData.forEach(progress => {
        if (
            progress.milestone !== ORDER_MILESTONES.ORDER_PLACED &&
            !progress.actualDate
        ) {
            pendingStages.push(progress)
        }
    })

    return pendingStages.length
        ? progressData.findIndex(
              milestoneData =>
                  milestoneData.milestone === pendingStages[0].milestone,
          )
        : null
}
